import { HomeGrid } from "../grids/HomeGrid";
import { useParams } from "react-router-dom";

export default function Home() {
  const { uid } = useParams();

  if (!uid) {
    return (
      <div style={{ textAlign: "center", marginTop: "20%", height: "800px" }}>
        <h2>Please select a site</h2>
      </div>
    );
  }

  return (
    <>
      <HomeGrid />
    </>
  );
}
